export function deepCopy(value) {
  return JSON.parse(JSON.stringify(value))
}

export const arabicDigit = (number) => {
  let myArray = number.split('')
  myArray.forEach((singleDigit, index) => {
    switch (singleDigit) {
      case '0':
        myArray[index] = '٠'
        break
      case '1':
        myArray[index] = '١'
        break
      case 2:
        myArray[index] = '٢'
        break
      case 3:
        myArray[index] = '٣'
        break
      case 4:
        myArray[index] = '٤'
        break
      case 5:
        myArray[index] = '٥'
        break
      case 6:
        myArray[index] = '٦'
      case 7:
        myArray[index] = '٧'
        break
      case 8:
        myArray[index] = '٨'
        break
      case 9:
        myArray[index] = '٩'
        break
    }
  })
  return number
}
/**
 * Filtered data from Map
 * @param {String} query any query
 * @param {Array} data Array of data
 * @param {Object} selectedItem Selected Item
 * @return {Array} filtered array
 */

export function filterdData(query, data, selectedItem) {
  if (selectedItem)
    return data.filter((item) => {
      if (selectedItem.id !== item.id)
        return Object.values(item).some((word) => String(word).toLowerCase().includes(query))
    })
  else
    return data.filter((item) => {
      return Object.values(item).some((word) => String(word).toLowerCase().includes(query))
    })
}
/**
 * Split error to field and error
 * @param {String} error generated error
 * @return {String} translated errot
 */

export function translatedError(error) {
  const fieldTitle = error.substring(4, this.title.length + 4)
  const errorTitle = error.substring(this.title.length + 5)
  return this.$t(`title.${fieldTitle}`) + ' ' + this.$t(`error.${errorTitle}`)
}

/**
 * Get Time from datetime
 * @param {DateTime} dateTime any datetime
 * @return {time} date
 */
export function getTime(dateTime) {
  return dateTime.split('T')[1]
}

export function objectDeepCopy(list) {
  return JSON.parse(JSON.stringify(list))
}

export function addPadInString(value, position = 'start', range = 2, padVal = '0') {
  if (position === 'start') {
    return `${value}`.padStart(range, `${padVal}`)
  } else return `${value}`.padEnd(range, `${padVal}`)
}

export function initializeValuesToDefault(Obj, defaultValue = '') {
  Object.keys(Obj).forEach((key) => {
    if (typeof Obj[key] === 'object') {
      initializeValuesToDefault(Obj[key])
    } else Obj[key] = defaultValue
  })
}


export const transformTextToCapitalize = (text) => {
  let capitalizeText = text
    .split('_')
    .map((val) => val.charAt(0).toUpperCase() + val.slice(1))
    .join(' ')
  return capitalizeText
}